import React from "react";
export default function CallOutcomeFields({ label, values = {}, onChange, omitFollowup = false }) {
  const field = (name, title, type = "text", required = false) => (
    <label key={name} className="block mb-3">
      <span className="block text-sm font-medium mb-1">
        {title}
        {required ? " *" : ""}
      </span>
      <input
        className="w-full rounded-lg border border-slate-300 bg-white p-2 text-sm"
        name={name}
        type={type}
        required={required}
        value={values[name] || ""}
        onChange={(event) => onChange(name, event.target.value)}
      />
    </label>
  );
  return (
    <>
      {!omitFollowup && ["À rappeler", "Rendez-vous obtenu"].includes(label) && (
        <>
          {label === "Rendez-vous obtenu" &&
            field("due", "Date du rendez-vous", "date", true)}
          {field(
            "time",
            label === "À rappeler"
              ? "Heure du rappel promise"
              : "Heure du rendez-vous",
            "time",
            true,
          )}
          <p className="text-sm text-amber-700">
            La date convenue est conservée. Un conflit avec un jour non ouvré
            sera signalé.
          </p>
        </>
      )}
      {label === "Besoin futur" && (
        <>
          {field("futureDate", "Date estimée du besoin", "date")}
          {field("futurePeriod", "Ou période estimée (ex. début janvier)")}
        </>
      )}
      {label === "Devis accepté" && (
        <p className="text-sm">
          L’acceptation déclarée doit être vérifiée. Elle ne remplace pas
          une signature.
        </p>
      )}
      {label === "Plaquette envoyée" && (
        <>
          {field("channel", "Canal d’envoi (email, courrier…)", "text", true)}
          {field("sentAt", "Date d’envoi", "date")}
        </>
      )}
      {[
        "Travaille avec un concurrent",
        "Contrat exclusif avec un concurrent",
      ].includes(label) && (
        <>
          {label.startsWith("Contrat exclusif") &&
            field("competitor", "Nom du concurrent", "text", true)}
          {field("renewal", "Fin de contrat connue", "date")}
          <label className="block mb-3">
            Collaboration exclusive
            <select
              name="exclusive"
              value={values.exclusive || ""}
              onChange={(event) => onChange("exclusive", event.target.value)}
              className="w-full rounded-lg border bg-white p-2"
            >
              <option value="">Non connue</option>
              <option value="oui">Oui</option>
              <option value="non">Non</option>
            </select>
          </label>
          {field("satisfaction", "Satisfaction / insatisfaction (si connue)")}
        </>
      )}
      {label === "Tarifs trop élevés" && (
        <>
          {field("competitorPrice", "Tarif concurrent connu (€)", "number")}
          <label className="block mb-3">
            <input
              type="checkbox"
              name="managerTask"
              checked={!!values.managerTask}
              onChange={(event) =>
                onChange("managerTask", event.target.checked)
              }
            />{" "}
            Demander une validation tarifaire au responsable
          </label>
          <p className="text-sm">
            Aucune remise n’est accordée automatiquement.
          </p>
        </>
      )}
      {label === "Refus de collaboration" && (
        <>
          <label className="block mb-3">
            Nature du refus *
            <select
              required
              name="refusalType"
              className="w-full rounded-lg border bg-white p-2"
              value={values.refusalType || ""}
              onChange={(event) => onChange("refusalType", event.target.value)}
            >
              <option value="">Choisir</option>
              <option value="temporaire">Temporaire</option>
              <option value="définitif">Définitif</option>
            </select>
          </label>
          <label className="block mb-3">
            <input
              type="checkbox"
              name="opposition"
              checked={!!values.opposition}
              onChange={(event) => onChange("opposition", event.target.checked)}
            />{" "}
            Opposition explicite à toute nouvelle prospection
          </label>
        </>
      )}
      {[
        "Entreprise en liquidation judiciaire",
        "Entreprise en redressement judiciaire",
      ].includes(label) && (
        <p className="rounded-lg bg-amber-50 p-3 text-sm">
          La situation déclarée sera soumise à vérification. L’historique et les
          documents sont conservés.
        </p>
      )}
    </>
  );
}
